import { render, staticRenderFns } from "./myCourseList.vue?vue&type=template&id=7a0965ce"
import script from "./myCourseList.vue?vue&type=script&lang=js"
export * from "./myCourseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports